module.exports = __webpack_public_path__ + "static/media/csm_AdobeStock_87208847_4457727942.dead89d1.png";